<template>
  <div class="threads-box" v-if="flag==index&&detailShow" id="threadsBox">
    <div class="threads-title">
      <span>{{$t('language.common.targetCloud')}}</span>
    </div>
    <!-- 显示多个线程任务的首条信息 -->
    <div :class="collapseIndex==-2?'collapse-thread-box':''" class="thread-box" :style="{height:collapseIndex==-2?240+'px':''}">
      <div class="thread-all-backgroud">
          <!-- 显示进度背景颜色 -->
        <div class="thread-all-back" v-show="showStatus(syncItem)=='threadPercent'" :style="{width:syncItem.percent+'%'}">
        </div>
      </div>
      <div class="thread-detail-bottom">
        <div class="thread-name">
          <div style="float:left">{{$t('language.common.target')}}: </div>
          <div class="thread-catelog" @click.stop="toAimCatalog(syncItem)" :title="syncItem.toItem.nodes|getCatalog|getCatalogTitle">{{syncItem.toItem.nodes|getCatalog}}</div>
        </div>

        <div class="icon-util  white-up-position" :class="collapseIndex ==-2?'purple-down':'white-up'" @click="collapsePage(-2,syncItem)"></div>
        <div class="thread-status">
            <!-- 显示进度数字 -->
          <div class="thread-status-name" v-if="showStatus(syncItem)=='threadPercent'">
            <div v-if="syncItem.percent">{{syncItem.percent}}%</div>
            <div v-if="!syncItem.percent">0%</div>
          </div>
          <div class="thread-status-name" v-if="showStatus(syncItem)=='threadFailure'">{{$t('language.common.failure')}}</div>
          <div class="thread-status-name partical-color" v-if="showStatus(syncItem)=='particalStatus'">{{$t('language.common.partialSuccess')}}</div>
          <div class="thread-status-name color-green" v-if="showStatus(syncItem)=='threadSuccess'">{{$t('language.common.success')}}</div>
          <div class="thread-status-name" v-if="showStatus(syncItem)=='threadWaiting'">{{$t('language.common.waiting')}}...</div>
          <div class="thread-status-name" v-if="showStatus(syncItem)=='threadCancel'">{{$t('language.common.canceled')}}</div>
          <!-- <div class="thread-status-name" v-if="showStatus(syncItem)=='threadRunning'">{{$t('language.common.running')}}</div> -->
          <div class="thread-status-name" v-if="showStatus(syncItem)=='threadCount'">
            {{$t('language.common.countFiles')}}:({{syncItem.syncDetail.readyFindFileCount}}{{$t('language.common.transferFiles')}},{{syncItem.syncDetail.totalBytes|formatByte}})</div>
        </div>
        <transition name="thread">
          <div class="sync-threads-detail" v-if="collapseIndex==-2" v-cloak>
            <div class="thread-detail">
              <sync-detail  ref="syncThreadDetail" :threadChange='threadChange' :flag='collapseIndex' :index='-2' :detailShow='detailShow' :itemSyncDetail='syncItem'></sync-detail>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <!-- 显示该条任务下的source同步任务的详细信息 -->
    <div :class="collapseIndex==index?'collapse-thread-box':''" class="thread-box" v-for="(itemSyncDetail, index) in syncItem.sources" :key="index" :style="{height:collapseIndex==index?240+'px':''}">
      <div class="thread-all-backgroud">
        <div class="thread-all-back" v-show="showStatus(itemSyncDetail)=='threadPercent'" :style="{width:itemSyncDetail.percent+'%'}">
        </div>
      </div>
      <div class="thread-detail-bottom">
        <div class="thread-name">
          <div style="float:left">{{$t('language.common.target')}}: </div>
          <div class="thread-catelog"  @click.stop="toAimCatalog(itemSyncDetail)" :title="itemSyncDetail.toItem.nodes|getCatalog|getCatalogTitle">{{itemSyncDetail.toItem.nodes|getCatalog}}</div>
        </div>
        <div class="thread-status">
          <div class="thread-status-name" v-if="showStatus(itemSyncDetail)=='threadPercent'">
            <div>{{itemSyncDetail.percent}}%</div>
          </div>
          <div class="thread-status-name" v-if="showStatus(itemSyncDetail)=='threadFailure'">{{$t('language.common.failure')}}</div>
          <div class="thread-status-name partical-color" v-if="showStatus(itemSyncDetail)=='particalStatus'">{{$t('language.common.partialSuccess')}}</div>
          <div class="thread-status-name color-green" v-if="showStatus(itemSyncDetail)=='threadSuccess'">
            {{$t('language.common.success')}}</div>
          <div class="thread-status-name" v-if="showStatus(itemSyncDetail)=='threadWaiting'">{{$t('language.common.waiting')}}...</div>
          <div class="thread-status-name" v-if="showStatus(itemSyncDetail)=='threadCancel'">{{$t('language.common.canceled')}}</div>
           <!-- <div class="thread-status-name" v-if="showStatus(itemSyncDetail)=='threadRunning'">{{$t('language.common.running')}}</div> -->
          <div class="thread-status-name" v-if="showStatus(itemSyncDetail)=='threadCount'">
            {{$t('language.common.countFiles')}}:({{itemSyncDetail.syncDetail.readyFindFileCount}}{{$t('language.common.transferFiles')}},{{itemSyncDetail.syncDetail.totalBytes|formatByte}})</div>
        </div>
        <div class="icon-util  white-up-position" :class="collapseIndex==index?'purple-down':'white-up'" @click="collapsePage(index,itemSyncDetail)"></div>
        <transition name="thread">
          <div class="sync-threads-detail" v-if="collapseIndex==index" v-cloak>
            <div class="thread-detail">
              <sync-detail ref="syncThreadDetail" :flag='collapseIndex' :index='index' :detailShow='itemDetailShow' :threadChange='threadChange' :itemSyncDetail='itemSyncDetail'></sync-detail>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import taskListUtils from "@/js/workspace/task_list_util.js";
import syncDetailPage from "@/components/common/tabs/tabs_task_list/tabs_sync_detail";
export default {
  props: ['syncItem', 'index', 'flag', 'detailShow', 'threadChange'],
  components: {
    'sync-detail': syncDetailPage
  },
  data: function () {
    return {
      collapseIndex: -1,
      clientHeight: 0,
      itemDetailShow: true,
      threadsDetail: this.detailShow,
      threadChangeSign:false
    }
  },
  watch: {
    threadsDetail: (newValue, oldValue) => {
      if (!newValue) {
        this.$parent.$refs.threadParents[this.index].style.height = 95 + 'px ';
        let dom = this.$parent.$refs.threadParents[this.index].parentElement;
        dom.style.height = 95 + 'px ';
        this.collapseIndex = -1;
      }
    },
    //监听父组件，强制渲染数据和父组件一致
    '$store.state.threadChange': function (newValue, oldValue) {
      this.$forceUpdate();
    }
  },
  mounted () {
    //初始化应该打开同步任务的界面高度 
    this.initSyncItemPage();
  },
  methods: {
    toAimCatalog(item){
     let name;
    if(item.toItem){
     name=item.toItem.name;
     }else{
     name=item.toItem.nodes[0].fileName;
    }
   let toItem = {
     driveId: item.toItem.driveId,
     nodes: item.toItem.nodes,
     driveType: item.toItem.driveType,
     name: name,
     id: item.toItem.id
    };
    //如果是多个的同步任务跳转到目标目录          
    this.$parent.toAimCatalog(toItem);                
    },
    initSyncItemPage(){
      this.$parent.$refs.threadParents.style.height = ((this.syncItem.sources.length) + 1) * 52 + 170 + 'px';
      let dom = this.$parent.$refs.threadParents.parentElement.parentElement;
      dom.style.height = ((this.syncItem.sources.length) + 1) * 52 +170 + 'px';
    },
    //打开或关闭界面
    collapsePage (index, itemSyncDetail) {
      let that = this;
     //console.log(itemSyncDetail);
      if (this.collapseIndex != index) {
        if (this.collapseIndex == -1) {
          this.collapseIndex = index;
          let height = that.$parent.$refs.threadParents.clientHeight;
          that.clientHeight = 200;
          that.$parent.$refs.threadParents.style.height = height + that.clientHeight + 'px ';
          let dom = that.$parent.$refs.threadParents.parentElement.parentElement;
          dom.style.height = height + that.clientHeight + 'px ';
          this.setSyncDetail(index,itemSyncDetail);
        } else {
          //打开界面  
          this.collapseIndex = index;
          this.setSyncDetail(index,itemSyncDetail);
        }
      } else {
        this.collapseIndex = -1;
        let height = this.$parent.$refs.threadParents.clientHeight;
        this.$parent.$refs.threadParents.style.height = height - this.clientHeight + 'px ';
        let dom = this.$parent.$refs.threadParents.parentElement.parentElement;
        dom.style.height = height - this.clientHeight + 'px ';
      }
    },
    setSyncDetail(index,itemSyncDetail){
     if(!itemSyncDetail.syncDetail&&localStorage.getItem('syncDetail'+itemSyncDetail.id)&&localStorage.getItem('syncDetail'+itemSyncDetail.id)!="null"&&JSON.parse(Base64.decode(localStorage.getItem('syncDetail'+itemSyncDetail.id)))){
          let Base64 = require('js-base64').Base64;
              if(index!=-2){
                   this.syncItem.sources[index].syncDetail=JSON.parse(Base64.decode(localStorage.getItem('syncDetail'+itemSyncDetail.id)));
              }else{
                   this.syncItem.syncDetail=JSON.parse(Base64.decode(localStorage.getItem('syncDetail'+itemSyncDetail.id)));
              }
          }
    },
    //关闭界面
    closePage () {
      this.$parent.$refs.threadParents.style.height = 95 + 'px ';
      let dom = this.$parent.$refs.threadParents.parentElement.parentElement;
      dom.style.height = 95 + 'px ';
      this.collapseIndex = -1;
    },
    showHaveDoneStatus(syncItem){
        let flag=true;
          if(syncItem.syncDetail && syncItem.syncDetail.response ){
           if(!isNaN(syncItem.syncDetail.response)){
               flag=false;
              return flag;
           }
        }
        return flag;
    },
    showStatus(syncItem){
     //0.显示counting状态 1.waiting状态 2.running状态  3.显示进度状态 4.取消状态 5.部分成功状态  6.失败状态 7.成功状态
     let flag;
     //0.count状态
     if(syncItem.syncDetail&&syncItem.syncDetail.runningStatus==1){
       flag='threadCount';
       return flag;
     }
     //1.waiting状态
     if ((syncItem.syncDetail && syncItem.syncDetail.runningStatus == 0 && syncItem.syncDetail.percent != 100 && syncItem.status!='Done') || (!syncItem.syncDetail&& syncItem.status!='Done')) {
        flag = 'threadWaiting';
         return flag;
      }
      // 2.running状态
    //   if ( syncItem.percent != '100'  && (syncItem.status == 'Running' || syncItem.status == 'Waiting')) {
    //     flag = 'threadRunning';
    //     return flag;
    //     }
      //3.显示进度状态
     if(syncItem.syncDetail&&syncItem.syncDetail.runningStatus>1&&!isNaN(syncItem.syncDetail.response)){
          flag = 'threadPercent';
           return flag;
         } 
     // 任务必须完成
     if(this.showHaveDoneStatus(syncItem)){
        //4.取消状态
         if (syncItem.status == 'Done'  && (syncItem.result == 'cancel'||(syncItem.syncDetail&&syncItem.syncDetail.response&&syncItem.syncDetail.response=='cancel'))) {
            flag = 'threadCancel';
             return flag;
          }
        //详情存在情况下的5部分成功状态   //6失败状态
        if(syncItem.syncDetail){
            if(syncItem.syncDetail.errorList){
            if(syncItem.syncDetail.errorList.length){
               if((syncItem.syncDetail.errorList.length/syncItem.syncDetail.totalFileCount)*100<20){
                 flag='particalStatus';
                 return flag;
               }else{
                  flag = 'threadFailure';
                  return flag;
               }
            }else{ //7. 成功状态
                if(syncItem.percent==100){
                     flag='threadSuccess';
                     return flag;    
                }
            }
           }
        }else{  //5部分成功状态   //6失败状态
        if(syncItem.status=='Done'){
            if(syncItem.errorFileCount){
                if((syncItem.errorFileCount/syncItem.totalFileCount)*100<20){
                flag='particalStatus';
                return flag;
                }else{
                flag = 'threadFailure';
                return flag;
               }
            }else{ //7. 成功状态
                 if(syncItem.status!='Running'&&syncItem.status!='Waiting'&&syncItem.result!='error'){
                     flag='threadSuccess';
                     return flag;           
                 }
            }
           }
         }
     }else{//任务内存满了在运行过程中取消
        if(syncItem.syncDetail&&syncItem.syncDetail.runningStatus == -1){
             flag = 'threadCancel';
             return flag;
        }
         if(syncItem.syncDetail){
            if(syncItem.syncDetail.errorList){
            if(syncItem.syncDetail.errorList.length){
               if((syncItem.syncDetail.errorList.length/syncItem.syncDetail.totalFileCount)*100<20){
                 flag='particalStatus';
                 return flag;
               }else{
                  flag = 'threadFailure';
                  return flag;
               }
            }
         }
         }


     }
     return flag;

    }

  },
}
</script>

<style scoped>
.partical-color{
    color: #4281ff;
}
.threads-box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  /*no*/
  font-size: 12px;
  /*no*/
  color: #6f7886;
}

.collapse-threads-box {
  height: calc(100% + 300px);
}

.threads-title {
  color: black;
  font-weight: bold;
  margin-bottom: 20px;
  /*no*/
}

.thread-box {
  width: 100%;
  height: 40px;
  /*no*/
  border: 1px solid #eff5fd;
  /*no*/
  margin-bottom: 10px;
  /*no*/
  line-height: 40px;
  /*no*/
  position: relative;
}

.thread-name {
  margin-left: 1.5%;
  float: left;
  width: 40%;
  height: 40px;
  /*no*/
}

.thread-speed {
  float: left;
  width: 130px;
  /*no*/
  height: 40px;
  /*no*/
}

.thread-status {
  float: right;
  width: 30%;
  height: 40px;
  /*no*/
}

.thread-status-name {
  height: 100%;
  text-align: right;
  float: right;
  position: relative;
  left: -40px;  /*no*/
}

.color-green {
  color: #24d45a;
}

.color-blue {
  color: #4281ff;
}

.color-grey {
  color: #bfbfbf;
}

.color-red {
  color: red;
}

.white-up-position {
  position: absolute;
  top: 10px;
  /*no*/
  bottom: 0;
  right: 10px;
  /*no*/
  z-index: 800;
}

.collapse-thread-box {
  width: 100%;
  height: 340px;
  /*no*/
  border: 1px solid #cdddf5;
  /*no*/
}

.threads-detail {
  position: relative;
  top: 40px;
  /*no*/
  width: 100%;
  height: 300px;
  /*no*/
}

.sync-threads-detail {
  position: relative;
  top: 40px;
  /*no*/
  width: 100%;
  height: 200px;
  /*no*/
}

.thread-detail {
  position: absolute;
  width: 100%;
  height: 100%;
}

.thread-enter-active {
  transition: all 0.3s ease;
  height: 200px;
  /*no*/
  position: relative;
  top: 0px;
  /*no*/
  overflow: hidden;
}

.thread-leave-active {
  transition: all 0s ease;
  height: 0px;
  /*no*/
  overflow: hidden;
}

.thread-enter,
.thread-leave {
  height: 0;
  opacity: 0;
}

.thread-catelog {
  float: left;
  max-width: 400px;
  /*no*/
  height: 40px;
  /*no*/
  /*no*/
  color: #4280fe;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.thread-catelog:hover{
    text-decoration: underline;
}

.thread-all-back {
  background: #e5f0ff;
  height: 35px;
  /*no*/
  position: absolute;
  top: 2.25px;
  /*no*/
  bottom: 0;
}

.thread-all-backgroud {
  width: 100%;
  height: 40px;
  /*no*/
  position: absolute;
  float: left;
}

.thread-detail-bottom {
  width: 100%;
  height: 40px;
  /*no*/
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_task_list/tabs_sync_threads.vue